import React from 'react'
import StackComp from './StackComp'

function StackHome() {
  const stack = [
    {
      title:'Flutter',
      subdescription:'App Development',
      description:'An open-source UI software development kit created by Google. It is used to develop applications for Android, iOS, Linux, Mac, Windows, Google Fuchsia, and the web from a single codebase.',
      img:'https://cdn.worldvectorlogo.com/logos/flutter-logo.svg'

    },
    {
      title: 'Node.js',
      subdescription: 'Backend Runtime',
      description: 'An open-source, cross-platform, back-end JavaScript runtime environment that runs on the V8 engine and executes JavaScript code outside a web browser   ',
      img: 'https://cdn.worldvectorlogo.com/logos/nodejs-icon.svg'
    }, {
      title: 'React',
      subdescription: 'Frontend Library',
      description: 'A JavaScript library for building user interfaces or UI components developed by Facebook and maintained by a community of developers and companie  ',
      img:'https://cdn.worldvectorlogo.com/logos/react-2.svg'
    },
  ]
    
    return (
<div className=" flex gap-4 flex-col  md:flex-row ">
    {
      stack.map((data,index)=>(
        <StackComp stack={data}/>
      ))
    }
  
</div>

  )
}

export default StackHome
